"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalDefault = void 0;

const jsx_runtime_1 = require("react/jsx-runtime");

const react_1 = __importDefault(require("react"));

const ModalWrapper_1 = require("../ModalWrapper");

const styles_1 = require("./styles");

const hooks_1 = require("../../../hooks");

const ModalDefault = props => {
  const {
    children,
    backdropBackgroundColor,
    onClose,
    parentRef,
    modalId
  } = props;
  const ref = react_1.default.useRef(null);

  const onCloseModal = e => {
    if (onClose) {
      onClose(e);
    }
  };

  (0, hooks_1.useOutsideClick)(ref, onCloseModal);
  return (0, jsx_runtime_1.jsx)(ModalWrapper_1.ModalWrapper, Object.assign({
    backgroundColor: backdropBackgroundColor,
    parentRef: parentRef,
    modalId: modalId
  }, {
    children: (0, jsx_runtime_1.jsx)(styles_1.StyledModalDefault, Object.assign({}, props, {
      ref: ref
    }, {
      children: children
    }), void 0)
  }), void 0);
};

exports.ModalDefault = ModalDefault;